var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 347.796,
    height: 182.192,
    viewBox: "0 0 347.796 182.192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8.775,
    y1: -12.897,
    x2: 9.569,
    y2: -12.897,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#232c3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#172339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142138"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -46.566,
    y1: -13.85,
    x2: -45.244,
    y2: -13.85,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66369",
    transform: "translate(-572.556 -761.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67068",
    d: "M859.342,872.245,892.2,943.273l3.7-.012-28.415-75.629Z",
    fill: "#a6aaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67069",
    d: "M825.352,873.763l-32.862,69.51-3.7-.012L817.2,872.185Z",
    fill: "#a6aaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67070",
    "data-name": "Path 67070",
    d: "M741.855,928.051l-16.7,14.616-19.69-13.859s6.7-2.247,18.192.814l11.76-9.883Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67071",
    "data-name": "Path 67071",
    d: "M838.541,847.431s-36.915,18.922-49.957,24.582-57.412,50.094-57.412,50.094,5.681,11.567,8.522,9.535c25.053-17.912,48.133-33.939,62.964-39.531,29.37-11.074,37.555-13.482,45.078-22.2C847.736,869.911,843.324,859.433,838.541,847.431Z",
    fill: "#2167be"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66368",
    "data-name": "Group 66368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67072",
    "data-name": "Path 67072",
    d: "M781.026,920.591l-4.815,21.666-24.073.481s4.072-5.777,15.146-10.111l3.631-14.925Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67073",
    "data-name": "Path 67073",
    d: "M839.437,842.627s-34.338,3.7-46.856,10.445S770.1,921.627,770.1,921.627s9.723,5.278,10.927,2a450,450,0,0,1,20.482-47.151c12.338-2.254,40.915,11.654,61.569-8.69C863.077,867.786,845.215,854.182,839.437,842.627Z",
    fill: "#277fd9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66369-2",
    "data-name": "Group 66369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67074",
    "data-name": "Path 67074",
    d: "M898.606,800.889a45.762,45.762,0,0,0-4.042,9.247l-14.124-1.3s7.292-11.049,6.734-17.75Z",
    fill: "#fec4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67075",
    "data-name": "Path 67075",
    d: "M895.57,778.061c-.8-.213-3.82-1.044-4.431-.795-.848.345.138,1.456-.459,2.134-.965,1.1-2.9,1.121-4.142,1.788a8.228,8.228,0,0,0-3.348,3.083c-1.15,2.021,3.038,6.532,3.694,9.913,1.372,7.072,10.311,8.118,17.573,5.953a12.6,12.6,0,0,0,6.4-5.374c1.663-2.662.725-7.112-.668-9.762a12.385,12.385,0,0,0-3.938-3.958c-1.309-.9-1.672-4.658-3.249-4.924C903,776.119,897.375,778.54,895.57,778.061Z",
    fill: "#fec4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67076",
    "data-name": "Path 67076",
    d: "M915.849,797.046c.016.014-.244-1.186,1.8-3.115,6.776-6.38-.472-18.86-7.856-21.033-3.777-1.112-6.192.06-7.547-3.694.1.269-1.527.958-1.688,1.094a2.927,2.927,0,0,0-1.336,2.517c-.125,5.454,4.755,10.532,8.449,13.967,1.661,1.545-2.426.479-4.074.794-1.072.205-3.855,3.144-4.452,3.589,1.549,1.928,2.928.187,5.016,1.119,1.93.861.707,3.316-1.091,3.607a3.778,3.778,0,0,1-3.92-1.387c-1.277.693-1.482,4.829-2.485,5.912,1.385.76,9.459,2.179,11.353,2.156A8.08,8.08,0,0,0,915.849,797.046Z",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67077",
    "data-name": "Path 67077",
    d: "M898.149,803.086c2.962,33.031-35.072,64.7-35.072,64.7s-24.833.934-23.64-25.159c0,0,1.933-4.745,17.306-18.677,10.271-9.309,17.487-23.2,24.715-22.924C901.2,801.781,898.149,803.086,898.149,803.086Z",
    fill: "#ff5e69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67078",
    "data-name": "Path 67078",
    d: "M805.905,869.608s22.9,8.542,53.429-3.036,38.854-65.646,38.854-65.646l3.492,1.771s-3.4,59.664-43.59,72.63c-30.725,9.912-52.185-1.893-52.185-1.893Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66370",
    "data-name": "Group 66370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67079",
    "data-name": "Path 67079",
    d: "M894.475,836.081s3.657,12.673,3.861,18.99-2.5,27.762-2.5,27.762l5.818.736s5.17-25.561,5.291-33.9-4.689-21.855-4.689-21.855Z",
    fill: "#f8d2a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67080",
    "data-name": "Path 67080",
    d: "M894.111,836.616c4.225,18.455,2.474,43.189,2.474,43.189l6.313.4c6.92-14.477,6.273-46.555,2.613-60.051-2.151-7.929-3.417-15.924-8.782-17.157-3.355-.771-10.254,1.684-11.178,5C883.545,815.192,892.039,827.563,894.111,836.616Z",
    fill: "#ff5e69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67081",
    "data-name": "Path 67081",
    d: "M893.236,886.022c-1.393,2.654-2.024,4.6-1.2,5.268.566.462,1.477-2.114,2.577-3.033a7.956,7.956,0,0,1-.32,4.766c-.777,1.913-.708,3.548.745,3.689s3.817.045,4.343-1.16,1.72-6.228,2.366-7.9-.211-3.593.035-4.551-4.292-2.56-4.292-2.56c-.249.385-1.648,2.292-1.648,2.292a14.692,14.692,0,0,1-1.584,1.668A5.6,5.6,0,0,0,893.236,886.022Z",
    fill: "#f8d2a1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66382",
    "data-name": "Group 66382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66375",
    "data-name": "Group 66375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66372",
    "data-name": "Group 66372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67082",
    "data-name": "Path 67082",
    d: "M617.982,789.836a30.742,30.742,0,0,1,4.331-7.117c2.793-3.353,6.957-8.936,6.957-8.936s-2.031,3.974-4.788,8.464A34.321,34.321,0,0,1,617.982,789.836Z",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67083",
    "data-name": "Path 67083",
    d: "M620.87,783.293a17.792,17.792,0,0,0,4.949-7.572c1.857-5.143,3.55-9.058,3.55-9.058a72.639,72.639,0,0,0-5.736,9.714C621.909,780.354,620.87,783.293,620.87,783.293Z",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67084",
    "data-name": "Path 67084",
    d: "M618.19,789.108a64.8,64.8,0,0,0,1.936-10.577c.317-4.7.282-7.644.282-7.644s-2.04,8.519-2.656,12.137A11.715,11.715,0,0,0,618.19,789.108Z",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67085",
    "data-name": "Path 67085",
    d: "M616.806,793.013a34.214,34.214,0,0,0-1.185-11.477,36.063,36.063,0,0,1-1.8-8.86,36.589,36.589,0,0,0,.153,10.565A70.057,70.057,0,0,0,616.806,793.013Z",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67086",
    "data-name": "Path 67086",
    d: "M617.307,791.675s4.3-3.675,6.479-4.539a25.828,25.828,0,0,0,5.2-3.384s-3.738,4.786-5.825,5.735S617.307,791.675,617.307,791.675Z",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67087",
    "data-name": "Path 67087",
    d: "M615.823,796.817a17.37,17.37,0,0,0-1.507-7.995,42,42,0,0,1-2.367-7.006s-.115,6.364,1.151,8.752S615.823,796.817,615.823,796.817Z",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67088",
    "data-name": "Path 67088",
    d: "M616.224,794.408a13.9,13.9,0,0,1,4.857-1.985,11.7,11.7,0,0,0,3.021-.659,5.649,5.649,0,0,1-4.146,2.575C617.015,794.71,616.224,794.408,616.224,794.408Z",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67089",
    "data-name": "Path 67089",
    d: "M614.607,799.974c.534-2.08,1.222-5.3,1.932-7.444a65.738,65.738,0,0,1,5.289-10.852c-2.275,5.045-3.936,7.881-5.079,12.231-.454,1.725-1.237,4.118-1.661,5.682C615.02,800.019,614.677,800.378,614.607,799.974Z",
    fill: "#50cc85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66373",
    "data-name": "Group 66373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67090",
    "data-name": "Path 67090",
    d: "M615.705,791.532a32.674,32.674,0,0,0-1.891-8.652c-1.648-4.337-3.9-11.389-3.9-11.389s.667,4.7,1.885,10.164A36.49,36.49,0,0,0,615.705,791.532Z",
    fill: "#77e6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67091",
    "data-name": "Path 67091",
    d: "M615.065,783.956a18.925,18.925,0,0,1-2.355-9.323c-.087-5.812-.434-10.333-.434-10.333a77.2,77.2,0,0,1,2.4,11.749C615.037,780.642,615.065,783.956,615.065,783.956Z",
    fill: "#77e6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67092",
    "data-name": "Path 67092",
    d: "M615.748,790.728a68.825,68.825,0,0,1,1.713-11.3c1.3-4.83,2.361-7.781,2.361-7.781s-.9,9.268-1.53,13.118A12.457,12.457,0,0,1,615.748,790.728Z",
    fill: "#77e6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67093",
    "data-name": "Path 67093",
    d: "M615.788,795.132a36.372,36.372,0,0,1,5.162-11.127,38.309,38.309,0,0,0,4.869-8.284,38.875,38.875,0,0,1-3.808,10.566A74.348,74.348,0,0,1,615.788,795.132Z",
    fill: "#77e6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67094",
    "data-name": "Path 67094",
    d: "M615.747,793.613s-3.054-5.182-4.941-6.8a27.4,27.4,0,0,1-4.06-5.2s2.1,6.1,3.871,7.78S615.747,793.613,615.747,793.613Z",
    fill: "#77e6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67095",
    "data-name": "Path 67095",
    d: "M615.461,799.295a18.453,18.453,0,0,1,4.279-7.515,44.662,44.662,0,0,0,4.8-6.223s-2.087,6.437-4.185,8.4S615.461,799.295,615.461,799.295Z",
    fill: "#77e6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67096",
    "data-name": "Path 67096",
    d: "M615.89,796.735a14.791,14.791,0,0,0-4.2-3.676,12.444,12.444,0,0,1-2.808-1.706,6,6,0,0,0,3.277,4.022C614.991,796.765,615.89,796.735,615.89,796.735Z",
    fill: "#77e6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67097",
    "data-name": "Path 67097",
    d: "M615.591,802.889c.182-2.275.6-5.745.633-8.15A69.908,69.908,0,0,0,614.662,782c.541,5.857,1.229,9.283.874,14.052-.141,1.89-.182,4.566-.3,6.284C615.16,802.792,615.381,803.272,615.591,802.889Z",
    fill: "#50cc85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66374",
    "data-name": "Group 66374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67098",
    "data-name": "Path 67098",
    d: "M612.433,792.426a30.716,30.716,0,0,0-4.331-7.117c-2.793-3.353-6.957-8.936-6.957-8.936s2.031,3.974,4.788,8.464A34.32,34.32,0,0,0,612.433,792.426Z",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67099",
    "data-name": "Path 67099",
    d: "M609.545,785.883a17.791,17.791,0,0,1-4.949-7.572c-1.857-5.143-3.55-9.059-3.55-9.059a72.609,72.609,0,0,1,5.736,9.715C608.506,782.944,609.545,785.883,609.545,785.883Z",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67100",
    "data-name": "Path 67100",
    d: "M612.225,791.7a64.8,64.8,0,0,1-1.936-10.577c-.317-4.7-.282-7.644-.282-7.644s2.04,8.519,2.656,12.137A11.715,11.715,0,0,1,612.225,791.7Z",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67101",
    "data-name": "Path 67101",
    d: "M613.609,795.6a34.22,34.22,0,0,1,1.185-11.478,36.051,36.051,0,0,0,1.8-8.859,36.591,36.591,0,0,1-.153,10.565A70.069,70.069,0,0,1,613.609,795.6Z",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67102",
    "data-name": "Path 67102",
    d: "M613.108,794.265s-4.3-3.675-6.479-4.54a25.791,25.791,0,0,1-5.2-3.383s3.738,4.785,5.825,5.734S613.108,794.265,613.108,794.265Z",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67103",
    "data-name": "Path 67103",
    d: "M614.592,799.407a17.38,17.38,0,0,1,1.506-8,41.983,41.983,0,0,0,2.368-7.005s.114,6.364-1.151,8.752S614.592,799.407,614.592,799.407Z",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67104",
    "data-name": "Path 67104",
    d: "M614.19,797a13.909,13.909,0,0,0-4.857-1.985,11.684,11.684,0,0,1-3.02-.658,5.647,5.647,0,0,0,4.146,2.574C613.4,797.3,614.19,797,614.19,797Z",
    fill: "#50cc85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67105",
    "data-name": "Path 67105",
    d: "M615.808,802.563c-.534-2.08-1.223-5.295-1.932-7.443a65.692,65.692,0,0,0-5.289-10.852c2.275,5.044,3.936,7.881,5.079,12.231.454,1.724,1.237,4.117,1.66,5.681C615.4,802.608,615.738,802.968,615.808,802.563Z",
    fill: "#50cc85"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67106",
    "data-name": "Path 67106",
    d: "M621.272,817.087H609.606L606,796.537h19.3Z",
    fill: "#d2dceb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66377",
    "data-name": "Group 66377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66376",
    "data-name": "Group 66376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67107",
    "data-name": "Path 67107",
    d: "M754.567,822.733l19.241,120.306,3.7-.012L762.288,822.708Z",
    fill: "#a6aaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67108",
    "data-name": "Path 67108",
    d: "M621.928,822.788,596.869,943.214l-4.99.012,19.646-120.413Z",
    fill: "#a6aaab"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26761",
    "data-name": "Rectangle 26761",
    width: 207.025,
    height: 9.265,
    transform: "translate(582.482 815.701)",
    fill: "#a6aaab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26762",
    "data-name": "Rectangle 26762",
    width: 226.877,
    height: 6.151,
    transform: "translate(572.556 815.701)",
    fill: "#a6aaab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66379",
    "data-name": "Group 66379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66378",
    "data-name": "Group 66378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67109",
    "data-name": "Path 67109",
    d: "M735.988,812.458h-8.053l-8.052-51.377h6.122Z",
    fill: "#a6aeba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67110",
    "data-name": "Path 67110",
    d: "M733.676,812.458H702.249L694.2,761.081h31.428Z",
    fill: "#d2dceb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26763",
    "data-name": "Rectangle 26763",
    width: 34.162,
    height: 3.833,
    transform: "translate(701.826 811.293)",
    fill: "#d2dceb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26764",
    "data-name": "Rectangle 26764",
    width: 43.072,
    height: 3.833,
    transform: "translate(735.988 811.293)",
    fill: "#a6aeba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67111",
    "data-name": "Path 67111",
    d: "M716.416,789.268c.909,3.933.269,8.181-1.43,9.488s-3.814-.822-4.724-4.755-.269-8.181,1.43-9.488S715.506,785.335,716.416,789.268Z",
    fill: "#a6aeba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66381",
    "data-name": "Group 66381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67112",
    "data-name": "Path 67112",
    d: "M667.529,814.946h-4.458a3.735,3.735,0,0,1-3.691-3.162L657.6,800.313H673l-1.78,11.471A3.737,3.737,0,0,1,667.529,814.946Z",
    fill: "#a6aeba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66380",
    "data-name": "Group 66380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67113",
    "data-name": "Path 67113",
    d: "M671.659,812.5c-.162,0-.325-.005-.493-.018l-.208-.016-.166-.128c-.112-.084-2.713-2.121-2.713-5.035,0-2.985,1.982-5.414,4.418-5.414a4.613,4.613,0,0,1,3.587,1.525,4.681,4.681,0,0,1,.822,4.013h0C676.32,810.677,674.419,812.5,671.659,812.5Zm-.168-1.4c2.813.089,3.7-2.067,4.034-3.918h0a3.37,3.37,0,0,0-.518-2.863,3.222,3.222,0,0,0-2.51-1.023c-1.662,0-3.015,1.8-3.015,4.011A5.608,5.608,0,0,0,671.491,811.1Z",
    fill: "#a6aeba"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_67114",
    "data-name": "Path 67114",
    d: "M656.064,815.954h19.52l3.113-3.447H652.951Z",
    fill: "#d2dceb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/error_image.b62f10d589b534c8771a166a92473474.svg";
export { ForwardRef as ReactComponent };